<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="''"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="tit_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Healthcare Providers,</div>
						<div class="tit">Receive 20% Off Your First Order</div>
					</div>
					<div class="bot_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Sign up for special offers on rapid testing products your patients need.<br />
						<div
							class="btn_box btn_el"
							@click="goForm"
						>
							SUBMIT<img src="../../assets/img/icon_w.webp" />
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx is committed to your privacy. CorDx uses the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information, see our privacy policy below.
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">
							<div class="tit1">
								Transforming Global Diagnostics
							</div>
							<div class="tit2">
								A leader in IVD R&D, manufacturing, and<br />supply chain.
							</div>
						</div>
						<div class="right">
							<div class="txt">
								CorDx is transforming the global diagnostics industry with innovative R&D solutions, a vertically integrated supply chain, and manufacturing footprints in the United States and around the world. 
							</div>
							<div class="txt">
								With nearly two decades of IVD experience, CorDx is a leader in IVD research and development, manufacturing, and supply chain. Our proprietary line of rapid diagnostic products is recognized by families and medical professionals for reliability, affordability, and rapid results. 
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goForm() {
			window.location.href = 'https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=9503031&formid=1&h=AAFdikaIQ2PXFz401i3VE_HOLtHYK7BnQWKsJ4kggWf6fmweWho';
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	color: #000000;
	//块2
	.block_2{
		background-color: transparent;
		background-image: linear-gradient(180deg, #FFFFFF 20%, #F1ECE6 100%);
		.block_2_main{
			width: 100%;
			margin: 0 auto;
			padding: 50px 20px;
			.msg_box{
				padding-top: 50px;
				text-align: center;
				.right{
					.txt{
						font-size: 20px;
						padding: 10px 0;
					}
				}
				.left{
					.tit2{
						padding-top: 20px;
						font-size: 20px;
						color: #093a98;
					}
					.tit1{
						font-size: 40px;
						line-height: 1.2;
					}
				}
			}
			.title{
				text-align: center;
				font-size: 20px;
			}
		}
	}
	//块1
	.block_1{
		.block_1_main{
			.bot_box{
				padding: 24px 0 20px 0;
				background-image: linear-gradient(rgba(11, 49, 143, 1), rgba(11, 49, 143, 1));
				text-align: center;
				font-size: 20px;
				color: #ffffff;
				.btn_el{
					margin-top: 20px;
					background-color: #F26F32;
					color: #ffffff;
					border: none;
					font-size: 18px;
				}
			}
			.tit_box{
				width: 100%;
				margin: 0 auto;
				padding: 50px 20px 30px 20px;
				.tit{
					font-size: 36px;
					text-align: center;
				}
			}
		}
	}
	.btn_box{
		display: inline-block;
		padding: 2px 28px 0 28px;
		height: 40px;
		line-height: 40px;
		font-size: 20px;
		color: #0B318F;
		background: transparent;
		border-radius: 37px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 18px !important;
			min-width: 18px !important;
			position: relative;
			top: 9px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box:hover{
		img{
			transform: translateX(5px);
		}
	}
}
</style>
